var React = require('react');

function Fill (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"0,227.5 39.742,227.5 0,98 0,0 62.742,0 200.742,367.5 82.742,367.5 63.742,307 0,307 "}));
}

Fill.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"200.742px","height":"367.5px","viewBox":"0 0 200.742 367.5","enableBackground":"new 0 0 200.742 367.5","xmlSpace":"preserve"};

module.exports = Fill;

Fill.default = Fill;
